import { Input, Label } from '@startupquickstart/frontend';
import type { MinigameAuthoringPanelProps } from './types';

interface GuessSongConfig {
  audioUrl?: string;
  songTitle?: string;
  artist?: string;
  playDuration?: number;
}

const DEFAULTS: Required<GuessSongConfig> = {
  audioUrl: '',
  songTitle: '',
  artist: '',
  playDuration: 15,
};

export function GuessSongPanel({
  value,
  onChange,
  disabled,
}: MinigameAuthoringPanelProps<GuessSongConfig>) {
  const v = { ...DEFAULTS, ...(value ?? {}) };
  const set = (patch: Partial<GuessSongConfig>) => onChange({ ...v, ...patch });

  return (
    <div className="space-y-4 rounded-lg border bg-muted/30 p-4">
      <div className="space-y-1">
        <h4 className="text-sm font-semibold">Guess the song</h4>
        <p className="text-xs text-muted-foreground">
          Players hear a clip, then enter the title. Set the play duration to
          cap how much of the clip the renderer plays.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div className="space-y-1 sm:col-span-2">
          <Label>Audio URL</Label>
          <Input
            type="url"
            value={v.audioUrl}
            placeholder="https://..."
            disabled={disabled}
            onChange={(e) => set({ audioUrl: e.target.value })}
          />
        </div>
        <div className="space-y-1">
          <Label>Song title</Label>
          <Input
            value={v.songTitle}
            disabled={disabled}
            onChange={(e) => set({ songTitle: e.target.value })}
          />
        </div>
        <div className="space-y-1">
          <Label>Artist</Label>
          <Input
            value={v.artist}
            disabled={disabled}
            onChange={(e) => set({ artist: e.target.value })}
          />
        </div>
        <div className="space-y-1">
          <Label>Play duration (sec, 0 = full clip)</Label>
          <Input
            type="number"
            min={0}
            max={600}
            value={v.playDuration}
            disabled={disabled}
            onChange={(e) => set({ playDuration: Number(e.target.value) })}
          />
        </div>
      </div>
    </div>
  );
}
